import { useState } from "react";
import Modal from "react-modal";
import { useFunctionsPrevia } from "../hooks/useFunctionsPrevia"; 

// Modal a pantalla completa
const fullScreenStyles = {
  content: {
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    padding: "20px",
    border: "none",
    borderRadius: "0",
    overflow: "auto",
    fontFamily: "Arial, sans-serif",
    fontSize: "16px",
    lineHeight: "1.5",
  },
  overlay: {
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: 130,
  },
};

const FacturaDetallesModal = ({ isOpen, onRequestClose, factura, onlyDetails = false }) => {
  const [activeTab, setActiveTab] = useState("detalles");
  const { formatDate } = useFunctionsPrevia();

  const formatearNumero = (num) =>
    new Intl.NumberFormat("es-MX", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);

  const getSubtotal = (f) =>
    f?.conceptos?.reduce((sum, c) => sum + (parseFloat(c.Importe) || 0), 0) ||
    0;

  const getTotal = (f) => {
    const sub = getSubtotal(f);
    const iva = sub * 0.16;
    return sub + iva;
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={fullScreenStyles}
      contentLabel="Detalles de Factura"
    >
      {/* Encabezado de pestañas */}
      <div
        style={{
          display: "flex",
          borderBottom: "1px solid #ddd",
        }}
      >
        {(onlyDetails ? ["detalles"] : ["detalles", "facturas", "gastos", "historial"]).map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            style={{
            background: "transparent",
            border: "none",
            padding: "8px 16px",
            cursor: "pointer",
            fontWeight: activeTab === tab ? "bold" : "normal",
            color: activeTab === tab ? "#007bff" : "#555",  // ← aquí el color de la letra
            transition: "color 0.2s",
            }}
          >
            {tab === "detalles"
              ? "Detalles"
              : tab === "facturas"
              ? "Facturas"
              : tab === "gastos"
              ? "Gastos"
              : "Historial"}
          </button>
        ))}
        <button
          onClick={onRequestClose}
          className="modal-close"
        >
          <i className="bi bi-x-lg"></i>
        </button>
      </div>

      {/* Contenido de la pestaña "Detalles" */}
      {activeTab === "detalles" && factura && (
        <div style={{ padding: "20px" }}>
          {/* Datos básicos */}
          <div
            style={{
              backgroundColor: "#F8F8FA",
              padding: "15px",
              borderRadius: "4px",
              marginBottom: "20px",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "10px",
            }}
          >
            <div style={{ paddingLeft: "40px" }}>
              <p>
                <strong>Folio:</strong> {factura.Folio}
              </p>
              <p>
                <strong>Cliente:</strong> {factura.receptor_Nombre}
              </p>
              <p>
                <strong>Forma de Pago:</strong> {factura.FormaPago}
              </p>
            </div>
            <div style={{ justifySelf: "end", paddingRight: "40px" }}>
              <p>
                <strong>Fecha:</strong> {formatDate(factura.Fecha)}
              </p>
              <p>
                <strong>Método de Pago:</strong> {factura.MetodoPago}
              </p>
              <p>
                <strong>Moneda:</strong> {factura.Moneda}
              </p>
            </div>
          </div>

          {/* Tabla de conceptos */}
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginBottom: "20px",
            }}
          >
            <thead>
              <tr>
                {["#", "Descripción", "Cant.", "V. Unit.", "Importe"].map(
                  (hdr) => (
                    <th
                      key={hdr}
                      style={{
                        textAlign: "center",
                        padding: "8px",
                        borderBottom: "1px solid #ddd",
                      }}
                    >
                      {hdr}
                    </th>
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {factura.conceptos?.map((c, i) => {
                const valorUnitario = parseFloat(c.ValorUnitario) || 0;
                const importe = parseFloat(c.Importe) || 0;
                return (
                  <tr key={i}>
                    <td style={{ textAlign: "center", padding: "8px" }}>
                      {i + 1}
                    </td>
                    <td style={{ padding: "8px" }}>{c.Descripcion}</td>
                    <td style={{ textAlign: "center", padding: "8px" }}>
                      {c.Cantidad}
                    </td>
                    <td style={{ textAlign: "center", padding: "8px" }}>
                      {formatearNumero(valorUnitario)}
                    </td>
                    <td style={{ textAlign: "center", padding: "8px" }}>
                      {formatearNumero(importe)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {/* Totales */}
          <div style={{ textAlign: "right", fontWeight: "bold" }}>
            <p>Subtotal: {formatearNumero(getSubtotal(factura))}</p>
            <p>IVA (16%): {formatearNumero(getSubtotal(factura) * 0.16)}</p>
            <p>Total: {formatearNumero(getTotal(factura))}</p>
          </div>
        </div>
      )}

      {/* Aquí podrías añadir el contenido de las otras pestañas "facturas", "gastos" o "historial" */}
    </Modal>
  );
};

export default FacturaDetallesModal;